// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LinkIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LinkIcon" ref={forwardedRef} {...props}>
      <path d="M12.498 4.123H12.5l3.18 3.184-4.603 4.585-1.584-1.583-1.06 1.06 1.414 1.414a1.75 1.75 0 0 0 2.475 0l4.242-4.242a1.75 1.75 0 0 0 0-2.475l-2.828-2.829a1.75 1.75 0 0 0-2.475 0L9.848 4.652l1.06 1.06z" />
      <path d="M7.002 15.88 3.82 12.699v-.002l4.592-4.599 1.594 1.594 1.061-1.06-1.414-1.414a1.75 1.75 0 0 0-2.475 0L2.935 11.46a1.75 1.75 0 0 0 0 2.475l2.829 2.829a1.75 1.75 0 0 0 2.475 0l1.414-1.415-1.06-1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LinkIcon = /* @__PURE__ */ Object.assign(LinkIconComponent, {
  displayName: 'LinkIcon',
});
